import * as React from "react"
const PaintBrush = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    transform="rotate(90)"
    viewBox="0 0 440.649 440.649"
    {...props}
  >
    <path
      d="M427.83 25.655c16.14 16.14-38.89 97.35-122.91 181.37-19.29 19.29-38.43 37.05-56.67 52.77l-.03-.03-54.5-54.5-.04-.04c15.73-18.24 33.48-37.37 52.77-56.66 84.03-84.03 165.23-139.06 181.38-122.91z"
      style={{
        fill: "#f2d59f",
      }}
    />
    <path
      d="m248.22 259.765.03.03c-13.46 11.61-26.42 22.1-38.6 31.27l-1.23-1.62-45.79-45.79-.05-.04c9.13-12.11 19.57-25.01 31.1-38.39l.04.04 54.5 54.5z"
      style={{
        fill: "#ff7124",
      }}
    />
    <path
      d="m208.42 289.445 1.23 1.62c-43.13 32.52-76.3 48.53-86.06 38.93-.2-.24-.41-.48-.64-.71-.02-.03-.05-.06-.08-.09-8.26-10.6 7.83-43.33 39.71-85.58l.05.04 45.79 45.79z"
      style={{
        fill: "#f2d59f",
      }}
    />
    <path
      d="M128.63 336.865c9.33 15.72 7.78 34.88-2.42 48.72l.02.01c-5.99 8.47-13.81 15.83-23.31 21.47-30.59 18.16-68.69 12.62-92.92-11.2 4.93-1.01 9.77-2.86 14.33-5.56 12.97-7.7 20.82-20.71 22.38-34.62.05-.07.04-.16.05-.21-.02-.26.02-.5.07-.8-.02-.03.01-.05-.01-.08l.04.01c1.46-13.31 8.89-25.8 21.29-33.16 18.14-10.77 40.88-7.04 54.72 7.75.03.03.06.06.08.09.18.23.38.45.59.66l.05.05c1.87 2.09 3.56 4.38 5.04 6.87z"
      style={{
        fill: "#8ecac1",
      }}
    />
    <path
      d="M131.863 342.735c-5.621.001-11.067-1.461-15.285-5.61l-.141-.141a16.995 16.995 0 0 1-1.131-1.248 9.554 9.554 0 0 1-.324-.394c-6.735-8.644-5.577-21.778 3.646-41.333 7.3-15.479 19.402-34.46 35.969-56.417 9.326-12.369 19.927-25.456 31.507-38.894 16.337-18.945 34.261-38.19 53.274-57.204 41.077-41.077 82.844-76.672 117.606-100.229 40.909-27.723 65.668-34.93 77.916-22.681 12.244 12.245 5.035 37.002-22.688 77.911-23.561 34.768-59.153 76.533-100.222 117.601-19.047 19.047-38.296 36.971-57.213 53.274-13.527 11.668-26.688 22.329-39.114 31.684-22.122 16.681-41.964 29.253-57.374 36.354-4.77 2.198-15.9 7.326-26.426 7.327zm-1.058-20.058c3.278.33 20.858-.413 72.825-39.596 12.079-9.095 24.893-19.475 38.089-30.858 18.547-15.985 37.431-33.569 56.13-52.269 38.12-38.12 71.701-77.168 94.557-109.951 25.425-36.468 29.005-52.98 28.208-57.135-4.146-.797-20.659 2.772-57.128 28.197-32.781 22.853-71.834 56.439-109.966 94.571-18.667 18.667-36.253 37.548-52.268 56.12-11.295 13.107-21.621 25.852-30.688 37.879-39.311 52.1-40.094 69.73-39.759 73.042z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M208.42 299.445a9.966 9.966 0 0 1-7.071-2.929l-45.79-45.79c-3.905-3.905-3.905-10.237 0-14.143 3.905-3.905 10.237-3.905 14.143 0l45.79 45.79c3.905 3.905 3.905 10.237 0 14.143a9.97 9.97 0 0 1-7.072 2.929zM248.22 269.766a9.966 9.966 0 0 1-7.071-2.929l-54.5-54.5c-3.905-3.905-3.905-10.237 0-14.143 3.905-3.905 10.237-3.905 14.143 0l54.5 54.5c3.905 3.905 3.905 10.237 0 14.143a9.975 9.975 0 0 1-7.072 2.929zM63.756 427.816c-22.182 0-44.145-8.479-60.767-24.819a10 10 0 0 1 5.004-16.927c3.921-.803 7.703-2.273 11.242-4.368 9.865-5.856 16.261-15.747 17.538-27.13l.017-.142c.017-.228.039-.438.063-.628a9.84 9.84 0 0 1 .187-1.286c2.131-16.681 11.568-31.098 26.007-39.67 21.658-12.859 49.843-8.883 67.058 9.444.066.069.131.138.195.208.281.294.56.604.854.952a54.251 54.251 0 0 1 6.074 8.305c11.008 18.547 9.992 41.687-2.534 59.168a10.12 10.12 0 0 1-.297.445c-6.988 9.882-15.86 18.056-26.37 24.295a86.608 86.608 0 0 1-44.271 12.153zm-33.855-29.191c20.58 12.104 46.65 12.465 67.915-.159 7.9-4.69 14.59-10.792 19.891-18.142.142-.229.293-.453.454-.671a34.082 34.082 0 0 0 1.87-37.684 34.147 34.147 0 0 0-3.892-5.305 8.477 8.477 0 0 1-.23-.267l-.079-.092a9.686 9.686 0 0 1-.398-.423c-10.854-11.462-28.557-13.924-42.176-5.838-9.273 5.504-15.27 14.854-16.455 25.652-.018.163-.04.325-.065.486a10.677 10.677 0 0 1-.164 1.272c-2.129 17.212-11.811 32.16-26.671 41.171z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M79.284 389.828a10.003 10.003 0 0 1-3.751-19.274 32.974 32.974 0 0 0 4.427-2.186 31.348 31.348 0 0 0 8.339-7.181l1.677-2.279c3.272-4.449 9.533-5.4 13.981-2.128 4.448 3.273 5.401 9.533 2.128 13.982l-1.81 2.46c-.083.112-.168.223-.256.332-3.847 4.794-8.51 8.837-13.858 12.017a53.154 53.154 0 0 1-7.133 3.526 9.98 9.98 0 0 1-3.744.731z"
      style={{
        fill: "#5e2a41",
      }}
    />
    <path
      d="M76.265 391.088a10.003 10.003 0 0 1-9.2-6.071c-2.171-5.078.186-10.955 5.264-13.126l3.04-1.3c5.079-2.17 10.955.186 13.126 5.264 2.171 5.078-.185 10.955-5.264 13.126l-3.04 1.3a9.982 9.982 0 0 1-3.926.807z"
      style={{
        fill: "#5e2a41",
      }}
    />
  </svg>
)
export default PaintBrush
